import { studentGateway } from '../student-gateway';

import {
    ILearningObjectiveSlides,
    NextLesson,
    NextLessonRes,
} from '@features/dashboard/types';

const requestedFields = ['id', 'title'];

const requestedInclude = ['slides'];
const fields = requestedFields.toString();
const include = requestedInclude.toString();

const getSlides = async (loId: number): Promise<ILearningObjectiveSlides> => {
    try {
        const response = await studentGateway.get(
            `/learning_objectives/${loId}`,
            {
                withCredentials: true,
                params: { fields, include },
            },
        );
        return response.data;
    } catch (error) {
        throw new Error('Something went wrong loading your slides.');
    }
};

const getNextLearningObjective = async (): Promise<NextLesson> => {
    try {
        const response = await studentGateway.get<NextLessonRes>(
            '/learning_objectives/next',
        );
        return response.data.next_lesson;
    } catch (error) {
        throw new Error('Something went wrong loading the next lesson data.');
    }
};

export { getSlides, getNextLearningObjective };
